var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCameraOff = function SvgCameraOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32.995 13.355-4.56 5.61a5.167 5.167 0 0 1-4.9 6.03l-4.562 5.614c1.349.547 2.823.848 4.368.848 6.421 0 11.625-5.204 11.625-11.625a11.57 11.57 0 0 0-1.97-6.477ZM11.986 39.207l5.305-6.529a14.118 14.118 0 0 0 13.008-.47l4.667 7h-22.98Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m5.724 42.669-.008.01L3 40.47l11.071-13.623a11.574 11.574 0 0 1-2.355-7.016c0-6.42 5.204-11.625 11.625-11.625 1.78 0 3.465.4 4.973 1.115L35.89 0l2.698 2.193L5.705 42.654l.019.015ZM23.34 14.666c.204 0 .405.011.602.034l-5.503 6.772a5.167 5.167 0 0 1 4.901-6.806Z",
    clipRule: "evenodd"
  })));
};
export default SvgCameraOff;